import { useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_DELAY_MS = 300;

const useDebouncedValue = <T>(
  value: T,
  delayMs = DEFAULT_DEBOUNCE_DELAY_MS
): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timeoutId);
  }, [value, delayMs]);

  return debouncedValue;
};

export default useDebouncedValue;
